import accordionJs from 'Assets/js/modules/library-modules/accordion-v2/accordion-v2.js';
import countdownJs from 'Assets/js/modules/library-modules/countdown/countdown.js';
import formSelection from 'Assets/js/modules/library-modules/form-selection/form-selection.js';
import socialMediaShareJs from 'Assets/js/modules/library-modules/social-media-share/social-media-share.js';
export default function contentContainerJs(block) {
	if (!block) {
		return;
	}
	accordionJs(block);
	countdownJs(block);
	formSelection(block);
	socialMediaShareJs(block);
}
